import { render } from "./PreviousLecture.vue?vue&type=template&id=4b1e4885&scoped=true"
import script from "./PreviousLecture.vue?vue&type=script&lang=js"
export * from "./PreviousLecture.vue?vue&type=script&lang=js"

import "./PreviousLecture.vue?vue&type=style&index=0&id=4b1e4885&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1e4885"]])

export default __exports__